import v1 from './v1.js'
import v2 from './v2.js'
import v6 from './v6.js'
import cn from './cn.js'
import { deepObjectMerge } from '@/utils/utils.js'
export default deepObjectMerge(
  v1,
  v2,
  cn,
  v6
)



// WEBPACK FOOTER //
// ./src/i18n/languages/zh_cn/index.js